/**
 * @fileoverview Split Screen Slideshow Implementation
 * @description Implements a synchronized dual-slideshow system with split screen layout
 *
 * Dependencies:
 * - jQuery
 * - Swiper.js
 *
 * HTML Structure Required:
 * - Element with class "split-screen-slideshow__section" containing:
 *   * Element with class "split-screen-slideshow" with data attributes:
 *     - data-autoplay: Boolean for autoplay functionality
 *     - data-stop-autoplay: Boolean for pause on hover
 *     - data-delay: Delay between slides in seconds
 *     - data-parallax: Boolean for parallax effect
 *     - data-effect: String for slide effect type
 *     - data-speed: Animation speed in seconds
 *   * Element with class "split-screen-slideshow__image-swiper" for image slideshow
 *   * Element with class "split-screen-slideshow__text-swiper" for text slideshow
 *   * Navigation elements with classes "swiper-button-next" and "swiper-button-prev"
 *   * Pagination element with class "swiper-pagination"
 */

(function () {
  /**
   * @function splitScreenSlid
   * @description Initializes and configures the split screen slideshow with multiple instances support
   */
  const splitScreenSlid = () => {
    $('.split-screen-slideshow__section').each(function () {
      if ($(this).hasClass('slider_started')) {
        return '';
      }
      $(this).addClass('slider_started');
      const id = $(this).attr('id');
      const box = $(this).find('.split-screen-slideshow');
      const autoplay = box.data('autoplay');
      const stopAutoplay = box.data('stop-autoplay');
      const delay = box.data('delay') * 1000;

      /**
       * @type {Object} Autoplay configuration parameters
       */
      if (autoplay) {
        autoplayParm = {
          autoplay: {
            delay: delay,
            pauseOnMouseEnter: stopAutoplay,
            disableOnInteraction: false,
          },
        };
      } else {
        autoplayParm = { autoplay: false };
      }

      /**
       * @type {Object} Base Swiper configuration parameters
       */
      let swiperParms = {
        parallax: box.data('parallax'),
        effect: box.data('effect'),
        speed: box.data('speed') * 1000,
        creativeEffect: {
          prev: {
            shadow: false,
            translate: [0, 0, -400],
          },
          next: {
            translate: ['100%', 0, 0],
          },
        },
        coverflowEffect: {
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: false,
        },
        flipEffect: {
          slideShadows: false,
        },
        loop: true,
        ...autoplayParm,
      };

      /**
       * @type {Swiper} Image slideshow instance
       */
      const swiperImg = new Swiper(
        `#${id} .split-screen-slideshow__image-swiper`,
        { ...swiperParms, autoplay: false, allowTouchMove: false }
      );

      /**
       * @type {Swiper} Text slideshow instance
       */
      const swiperText = new Swiper(
        `#${id} .split-screen-slideshow__text-swiper`,
        {
          navigation: {
            nextEl: `#${id} .swiper-button-next`,
            prevEl: `#${id} .swiper-button-prev`,
          },
          pagination: {
            el: `#${id} .swiper-pagination`,
            clickable: true,
          },
          ...swiperParms,
        }
      );

      // Link slideshows together
      swiperImg.controller.control = swiperText;
      swiperText.controller.control = swiperImg;

      colorScheme(swiperText);
      swiperText.on('beforeTransitionStart', function () {
        colorScheme(this);
      });

      /**
       * @function colorScheme
       * @description Updates the color scheme of navigation and pagination elements based on active slide
       * @param {Swiper} context - The Swiper instance
       */
      function colorScheme(context) {
        const activeIndex = context.activeIndex;
        const activeSlide = context.slides[activeIndex];
        const changeItems = [
          context.navigation.nextEl,
          context.navigation.prevEl,
          context.pagination.el,
        ];
        const colorScheme = $(activeSlide).data('color-scheme');
        changeItems.forEach((item) => {
          $(item)
            .removeClass('color-background-1')
            .removeClass('color-background-4')
            .addClass(colorScheme);
        });
      }
    });
  };

  // Initialize on page load and Shopify section load
  document.addEventListener('DOMContentLoaded', function () {
    splitScreenSlid();
  });
  document.addEventListener('shopify:section:load', function () {
    splitScreenSlid();
  });
})();
